import React, { useState, useEffect } from "react";
import { MdClose } from "react-icons/md";
import { FaRegCheckSquare, FaRegSquare } from "react-icons/fa";
import { CircularProgress } from "@mui/material";
import tw from "tailwind-styled-components";
import { Label, ModalHeader, ScrollableContent } from "../Styles/InputStyles";
import { GoSearch } from "react-icons/go";

export default function SelectCategoryModal({
    isOpen,
    onClose,
    onSelect,
    categories = [],
    selectedCategory,
    isLoading = false,
}) {
    const [searchText, setSearchText] = useState("");
    const [flattenedCategories, setFlattenedCategories] = useState([]);

    useEffect(() => {
        if (isOpen) {
            setSearchText("");
        }
    }, [isOpen]);

    useEffect(() => {
        const flattened = categories.flatMap(group =>
            group.items.map(item => ({
                ...item,
                groupName: group.name,
                label: item.label,
                value: item.value
            }))
        );
        setFlattenedCategories(flattened);
    }, [categories]);

    if (!isOpen) return null;

    const filteredCategories = flattenedCategories.filter((category) =>
        category.label.toLowerCase().includes(searchText.toLowerCase()) ||
        category.groupName.toLowerCase().includes(searchText.toLowerCase())
    );

    const handleSelect = (category) => {
        onSelect(category);
        onClose();
    };

    const isSelected = (value) => {
        return selectedCategory?.value === value;
    };

    const groupedCategories = filteredCategories.reduce((acc, category) => {
        if (!acc[category.groupName]) {
            acc[category.groupName] = [];
        }
        acc[category.groupName].push(category);
        return acc;
    }, {});

    return (
        <Overlay>
            <ModalWrapper>
                <ModalHeader>
                    <h1 className="text-white text-lg font-medium">Select Category</h1>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </ModalHeader>

                <div className="p-4 relative">
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Search categories..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="w-full px-8 h-12 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-primary-color text-gray-800 placeholder-gray-300"
                        />
                        <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                            <GoSearch className="w-4 h-4 text-gray-400" />
                        </div>
                    </div>
                </div>

                <ScrollableContent className="max-h-[calc(100dvh-140px)]">
                    {isLoading ? (
                        <div className="flex justify-center py-8">
                            <CircularProgress />
                        </div>
                    ) : filteredCategories.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                            No categories found
                        </div>
                    ) : (
                        Object.entries(groupedCategories).map(([groupName, groupCategories]) => (
                            <div key={groupName} >

                                <div className="px-4 py-1 bg-gray-100 border-gray-200">
                                    <Label className="text-gray-600 font-medium text-sm">
                                        {groupName}
                                    </Label>
                                </div>

                                {groupCategories.map((category) => (
                                    <OptionRow
                                        key={category.value}
                                        onClick={() => handleSelect(category)}
                                    >
                                        <Label>{category.label}</Label>
                                        <button disabled={isLoading}>
                                            {isLoading ? (
                                                <CircularProgress size={20} />
                                            ) : isSelected(category.value) ? (
                                                <FaRegCheckSquare size={20} className="text-primary-color font-normal text-sm" />
                                            ) : (
                                                <FaRegSquare size={20} className="text-gray-300 font-normal text-sm" />
                                            )}
                                        </button>
                                    </OptionRow>
                                ))}
                            </div>
                        ))
                    )}
                </ScrollableContent>
            </ModalWrapper>
        </Overlay>
    );
}

const Overlay = tw.div`fixed inset-0 z-50 flex items-center justify-end bg-black/50`
const ModalWrapper = tw.div`bg-white w-11/12 h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const OptionRow = tw.div`ml-2 flex items-center justify-between p-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50`;